import { pipedriveConstants } from '../_constants';
import { pipedriveService } from '../_services';

const pipedriveActions = {
    logout,
    getAllUsers,
    getAll,
    pendingToActive
};
export default pipedriveActions

function logout() {
    pipedriveService.logout();
    return { type: pipedriveConstants.LOGOUT };
}

function getAllUsers() {
    return async dispatch => {
        dispatch(request());

        await pipedriveService.getAllUsers()
            .then(
                pipedrive => dispatch(success(pipedrive)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: pipedriveConstants.GETALLUSERS_REQUEST } }
    function success(pipedrive) { return { type: pipedriveConstants.GETALLUSERS_SUCCESS, pipedrive } }
    function failure(error) { return { type: pipedriveConstants.GETALLUSERS_FAILURE, error } }
}

function getAll() {
    return async dispatch => {
        await dispatch(request());

        await pipedriveService.getAll()
            .then(
                pipedrive => dispatch(success(pipedrive)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: pipedriveConstants.GETALL_REQUEST } }
    function success(pipedrive) { return { type: pipedriveConstants.GETALL_SUCCESS, pipedrive } }
    function failure(error) { return { type: pipedriveConstants.GETALL_FAILURE, error } }
}

function pendingToActive(pipedrive) {
    return async dispatch => {
        await dispatch(request());

        await pipedriveService.pendingToActive(pipedrive)
            .then(
                message => dispatch(success(message)),
                error => dispatch(failure(error.toString()))
            );
    };
    
    function request() { return { type: pipedriveConstants.PENDINGTOACTIVE_REQUEST } }
    function success(message) { return { type: pipedriveConstants.PENDINGTOACTIVE_SUCCESS, message } }
    function failure(error) { return { type: pipedriveConstants.PENDINGTOACTIVE_FAILURE, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/pipedrive.actions.js